import { ClientDataShareConfigModel } from "@app/data-share/clientDataShareConfigModel";
import ServiceBase from "@app/shared/serviceBase";
import { DatabaseProvisionedAndPublishedStatus } from "@app/data-share/databaseProvisionedAndPublishedStatus";

class DataShareService extends ServiceBase {

  public async getClientDataShareConfig(clientId: number): Promise<ClientDataShareConfigModel> {
    if (!clientId) {
      return null;
    }

    return await this.makeGet<ClientDataShareConfigModel>(`dataShare/${clientId}`);
  }

  public async saveClientDataShareConfig(clientId: number, model: ClientDataShareConfigModel): Promise<void> {
    return await this.makePost<void>(`dataShare/${clientId}/save`, model);
  }

  public async getClientDatabaseProvisionedAndPublishedStatusAsync(clientId: number, signal?: AbortSignal): Promise<DatabaseProvisionedAndPublishedStatus> {
    return await this.makeGet<DatabaseProvisionedAndPublishedStatus>(
      `dataShare/${clientId}/status`,
      undefined,
      undefined,
      undefined,
      undefined,
      signal,
    );
  }
}

export {
  DataShareService,
};
